import axios from "axios";
import router from "../router";

// 创建一个axios实例
const ajax = axios.create({

 baseURL: process.env.NODE_ENV === 'production' ? 'https://api.vimiu3d.com/' : 'http://dev.erp.test/'

  // baseURL: 'https://test.vimiu3d.com/'  //测试
    // baseURL: 'https://api.vimiu3d.com/'  //日常使用
});

/**
 * 拦截器 -- 请求拦截--request，响应拦截--response
 */
ajax.interceptors.request.use(config => {
  /** 如果需要判断用户权限，那么要获取token */
  let token = localStorage.getItem("token");
  // let token = 'WEKFShQ%2BYD0V%2FsdmSyXFKNCatxYELlCLDKT5l3SbokkNSTb8SmgT7Y0ztf%2BsbOVte5eW67h0btq2faLOuVPOzCxrUSR%2F4khuYvJmYgjlz2A%3D'
  // if (!token) return Promise.reject({code: 900, message: '用户没有访问此接口的权限'})
  /** 有token，就应该把token添加到请求头上 */
  config.headers.token = token;
  return config;
});
ajax.interceptors.response.use(function(responseObject) {
  let { data } = responseObject;
  if (data.code == 1003) {
    // 提示用户登录已经时效--token没有
    // alert("用户的token已经失效，请重新登录");
    window.location.href = 'https://www.vimiu3d.com/manage/login/login';
  } else {
    return responseObject;
  }
});
/**
 * 封装的ajax请求
 * @param {{url: string, data: any, params: {} , | undefined, method: "POST" | "GET" | "PUT" | "DELETE"}} req 请求对象
 * @returns Promise
 */
export default function ajaxFunc(req) {
  console.log('333333');

  // 获取app容器
  const appDiv = document.getElementById('app');

  // 创建loading元素
  const loadingDiv = document.createElement('div');
  loadingDiv.id = 'loading';
  loadingDiv.style.position = 'absolute';
  loadingDiv.style.top = '0';
  loadingDiv.style.left = '0';
  loadingDiv.style.width = '100%';
  loadingDiv.style.height = '100%';
  loadingDiv.style.backgroundColor = 'rgba(0,0,0,0.5)';
  loadingDiv.style.color = 'white';
  loadingDiv.style.display = 'flex';
  loadingDiv.style.alignItems = 'center';
  loadingDiv.style.justifyContent = 'center';
  loadingDiv.style.zIndex = '100000'; // 确保loading层在最上面
  loadingDiv.innerText = 'Loading...';

  // 确保appDiv是相对定位
  if (getComputedStyle(appDiv).position === 'static') {
    appDiv.style.position = 'relative';
  }

  // 在请求开始时添加loading元素
  appDiv.appendChild(loadingDiv);

  return new Promise((resolve, reject) => {
    ajax
      .request({
        url: req.url,
        method: req.method || "post",
        headers: req.headers || {},
        data: req.data || {},
        params: req.params || {}
      })
      .then(({ data }) => {
        // 请求成功后移除loading元素
        appDiv.removeChild(loadingDiv);
        resolve(data);
      })
      .catch(e => {
        // 请求失败后移除loading元素
        appDiv.removeChild(loadingDiv);
        reject(e); // 更好的做法是reject错误
      });
  });
}



// WEBPACK FOOTER //
// ./src/api/ajax.js